import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useEffect } from 'react';
import { useNavigation, CaptionProps } from 'react-day-picker';
import { FormattedMessage } from 'react-intl';

interface CalendarHeaderProps extends CaptionProps {
  setCurrentMonth: (value: string) => void
}

const styles = {
  headerText: {
    fontFamily: 'Schibsted Grotesk',
    fontWeight: 600,
    fontSize: '24px',
  },
  bodyText: {
    fontFamily: 'Schibsted Grotesk',
    fontWeight: 400,
    fontSize: '16px',
  },
  iconButtonStyle: {
    border: '1px solid #E3E3E3',
    borderRadius: '6px 0px 0px 6px',
    padding: '12px 24px',
  },
};


const CalendarHeader = ({ setCurrentMonth, ...props }: CalendarHeaderProps) => {

  const { goToMonth, nextMonth, previousMonth } = useNavigation();

  useEffect(() => {
    setCurrentMonth(format(props.displayMonth, 'MMMM yyy'));
  }, [props.displayMonth, setCurrentMonth]);

  return (
    <Stack
      padding='20px 20px 0px 20px '
      direction='row'
      flexGrow={1}
      justifyContent='space-between'
      alignItems='center'
    >
      <Stack gap={1} marginBottom={2}>
        <Typography sx={styles.headerText}>
          {format(props.displayMonth, 'MMM yyy')}
        </Typography>
        <Typography sx={styles.bodyText}>
          <FormattedMessage defaultMessage='Please specify your availability for receiving live reports' />
        </Typography>
      </Stack>
      
      <Stack direction='row' alignItems='flex-end'>
        <IconButton
          sx={styles.iconButtonStyle}
          disabled={!previousMonth}
          onClick={() => previousMonth && goToMonth(previousMonth)}
        >
          <ChevronLeftIcon/>
        </IconButton>
        <IconButton
          sx={{ ...styles.iconButtonStyle, borderRadius: '0px 6px 6px 0px' }}
          disabled={!nextMonth}
          onClick={() => nextMonth && goToMonth(nextMonth)}
        >
          <ChevronRightIcon/>
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default CalendarHeader;